import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { ClientType } from '../../api';
import { getClientTypeColors, getClientTypeLabel } from '../../theme/ataTheme';

const useStyles = makeStyles({
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        height: '24px',
        padding: '0 10px 0 8px',
        borderRadius: tokens.borderRadiusCircular,
        fontSize: '12.5px',
        fontWeight: tokens.fontWeightSemibold,
        whiteSpace: 'nowrap',
        lineHeight: 1,
    },
    dot: {
        width: '7px',
        height: '7px',
        borderRadius: tokens.borderRadiusCircular,
        flex: 'none',
    },
});

interface ClientTypeBadgeProps {
    clientType?: ClientType | string;
    className?: string;
}

/**
 * Color-coded client-type pill (dot + label) using the fixed categorical
 * palette from ATA-Design-Standard.md §5 (NOT brand tokens).
 */
const ClientTypeBadge = ({ clientType, className }: ClientTypeBadgeProps) => {
    const styles = useStyles();
    const colors = getClientTypeColors(clientType);

    return (
        <span
            className={mergeClasses(styles.badge, className)}
            style={{ backgroundColor: colors.tint, color: colors.text }}
        >
            <span className={styles.dot} style={{ backgroundColor: colors.dot }} />
            {getClientTypeLabel(clientType)}
        </span>
    );
};

export default ClientTypeBadge;
